import Vue from 'vue'
import TurbolinksAdapter from 'vue-turbolinks'

// These files are ignored in eslint since this is generated by the system
import { Ziggy } from './ziggy'
import route from '../../vendor/tightenco/ziggy/dist/js/route.js'
import VCalendar from 'v-calendar'
import VueTippy, { TippyComponent } from 'vue-tippy'
import VeeValidate from 'vee-validate'
import { VueMasonryPlugin } from 'vue-masonry'
import Particles from 'particles.vue'

require('./bootstrap')
require('./filters')

var Turbolinks = window.Turbolinks = require('turbolinks')

Turbolinks.start()

/**
* Directives
*/
require('./directives/v-modal')
require('./directives/v-organization')

/**
 * [store description]
 * @type {[type]}
 */
const store = require('./store').default

Vue.component('ModalTrigger', require('@modals/ModalTrigger.vue').default)
Vue.component('EmailRequestModal', require('@modals/EmailRequestModal.vue').default)
Vue.component('SampleModal', require('@modals/SampleModal.vue').default)
Vue.component('VideoModal', require('@modals/VideoModal.vue').default)
Vue.component('PricingPlanModal', require('@modals/PricingPlanModal.vue').default)
Vue.component('VbcModal', require('@modals/VbcModal.vue').default)
Vue.component('EmailListModal', require('@modals/EmailListModal.vue').default)
Vue.component('OrganizationSelector', require('@components/OrganizationSelector.vue').default)
Vue.component('ScheduleDemo', require('@components/ScheduleDemo.vue').default)
Vue.component('Calendar', require('@components/Calendar.vue').default)
Vue.component('Guide', require('@components/Guide.vue').default)
Vue.component('PriceEstimate', require('@components/PriceEstimate.vue').default)
Vue.component('PricingCard', require('@components/PricingCard.vue').default)
Vue.component('PriceSlider', require('@components/PriceSlider.vue').default)
Vue.component('LogoCarousel', require('@components/LogoCarousel.vue').default)
Vue.component('CareerForm', require('@components/CareerForm.vue').default)
Vue.component('EmailVerification', require('@components/EmailVerification.vue').default)
Vue.component('ButtonLoader', require('@components/ButtonLoader.vue').default)
Vue.component('SupportSurvey', require('@components/SupportSurvey.vue').default)
Vue.component('ContactAgent', require('@components/ContactAgent.vue').default)
Vue.component('Faq', require('@components/Faq.vue').default)
Vue.component('PricingDetails', require('@components/PricingDetails.vue').default)
Vue.component('WatercoolerFeatures', require('@components/WatercoolerFeatures.vue').default)

Vue.component('UnsubscribeNewsletterModal', require('@modals/UnsubscribeNewsletterModal.vue').default)

/**
 * Forms
 */
Vue.component('FormText', require('@components/forms/FormText.vue').default)
Vue.component('FormSelect', require('@components/forms/FormSelect.vue').default)
Vue.component('FormTextarea', require('@components/forms/FormTextarea.vue').default)
Vue.component('FormFile', require('@components/forms/FormFile.vue').default)

/**
 * Icons
 */
Vue.component('FaqCube', require('@components/FaqCube.vue').default)
Vue.component('FaqLightBulb', require('@components/FaqLightBulb.vue').default)
Vue.component('FaqSend', require('@components/FaqSend.vue').default)
Vue.component('TsParticles', require('@components/TsParticles.vue').default)

/**
 * Mount event hub
 * @type {Vue}
 */
Vue.prototype.$eventHub = new Vue()

/**
 * Third party
 */
Vue.use(TurbolinksAdapter)
Vue.use(VCalendar)
Vue.use(VueTippy)
Vue.use(VeeValidate)

Vue.use(Particles)
/**
 * Custom Components
 */
Vue.component('tippy', TippyComponent)
Vue.use(VueMasonryPlugin)

/**
 * Global Mixins
 */
Vue.mixin({
  methods: {
    visit: (url) => Turbolinks.visit(url),
    route: (name, params, absolute) => route(name, params, absolute, Ziggy),
    reload () {
      var scrollPosition

      document.addEventListener('turbolinks:load', function () {
        if (scrollPosition) {
          window.scrollTo.apply(window, scrollPosition)
          scrollPosition = null
        }
      }, false)

      scrollPosition = [window.scrollX, window.scrollY]
      Turbolinks.visit(window.location, { action: 'replace' })
    }
  }
})

document.addEventListener('turbolinks:load', () => {
  /* eslint-disable no-new */
  new Vue({
    store,
    el: '#app'
  })
})

if (window.location.pathname.indexOf('unsub-newsletter') !== -1) {
  setTimeout(() => {
    const params = (new URL(document.location)).searchParams
    store.dispatch('modal/open', {
      name: 'unsubscribe-newsletter-modal',
      params: { cid: params.get('cid'), id: params.get('id') }
    }, 500)
  })
}
